export default {
  CALL_START: "call/CALL_START",
  CALL_JOIN: "call/CALL_JOIN",
  CALL_LEAVE: "call/CALL_LEAVE",
  CALL_ERROR: "call/CALL_ERROR",
  SET_CALL_STATUS: "call/SET_CALL_STATUS",
  SET_VOXIMPLANT_PARAMS: "call/SET_VOXIMPLANT_PARAMS"
};
